import React, { useEffect, useState } from 'react';

const getFoldersFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('folders') || '{}');
  } catch {
    return {};
  }
};

const FilterBar = ({ filters, setFilters, showFilters }) => {
  const [folders, setFolders] = useState(getFoldersFromStorage());

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setFolders(getFoldersFromStorage());
  }, [showFilters]);

  useEffect(() => {
    const onStorageUpdate = () => {
      setFolders(getFoldersFromStorage());
    };

    window.addEventListener('folders-updated', onStorageUpdate);

    return () => {
      window.removeEventListener('folders-updated', onStorageUpdate);
    };
  }, []);

  useEffect(() => {
    const folderKeys = Object.keys(folders);

    if (folderKeys.length > 0 && !filters.folder) {
      const firstFolderValue = folders[folderKeys[0]];

      setFilters((prev) => ({
        ...prev,
        folder: firstFolderValue
      }));
    }
  }, [folders, filters.folder, setFilters]);

  if (!showFilters) return null;

  const containerStyle = {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center'
  };

  const panelStyle = {
    marginTop: '8px',
    background: 'linear-gradient(135deg, #f5f9ff, #eef7ff)',
    padding: '12px 16px',
    borderRadius: '14px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: 'fit-content',
    maxWidth: '100%'
  };

  const rowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px 16px'
  };

  const blockStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center'
  };

  const labelStyle = {
    fontSize: '11px',
    fontWeight: 600,
    color: '#004DCF'
  };

  const inputStyle = {
    height: '30px',
    padding: '0 8px',
    borderRadius: '8px',
    border: '1px solid #bcd0f7',
    outline: 'none',
    background: '#fff',
    fontSize: '12px',
    boxSizing: 'border-box'
  };

  const folderStyle = {
    ...inputStyle,
    width: '180px'
  };

  const dateInput = {
    ...inputStyle,
    width: '128px'
  };

  const smallInput = {
    ...inputStyle,
    width: '66px'
  };

  const unitSelect = {
    ...inputStyle,
    width: '58px'
  };

  const limitInput = {
    ...inputStyle,
    width: '84px'
  };

  const inlineRowStyle = {
    display: 'flex',
    gap: '6px',
    alignItems: 'center'
  };

  return (
    <div style={containerStyle}>
      <div style={panelStyle}>
        <div style={rowStyle}>
          <div style={blockStyle}>
            <span style={labelStyle}>Папка</span>
            <select
              name="folder"
              value={filters.folder || ''}
              onChange={handleChange}
              style={folderStyle}
            >
              <option value="" disabled>
                Выберите папку
              </option>

              {Object.keys(folders).map((name) => (
                <option key={folders[name]} value={folders[name]}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          <div style={blockStyle}>
            <span style={labelStyle}>Дата</span>
            <div style={inlineRowStyle}>
              <input
                type="date"
                name="dateFrom"
                value={filters.dateFrom}
                onChange={handleChange}
                style={dateInput}
              />
              <input
                type="date"
                name="dateTo"
                value={filters.dateTo}
                onChange={handleChange}
                style={dateInput}
              />
            </div>
          </div>

          <div style={blockStyle}>
            <span style={labelStyle}>Сколько найти</span>
            <input
              type="number"
              name="limit"
              value={filters.limit}
              onChange={handleChange}
              placeholder="100"
              style={limitInput}
            />
          </div>
        </div>

        <div style={rowStyle}>
          <div style={blockStyle}>
            <span style={labelStyle}>Вес</span>
            <div style={inlineRowStyle}>
              <input
                type="number"
                name="weightFrom"
                value={filters.weightFrom}
                onChange={handleChange}
                placeholder="От"
                style={smallInput}
              />
              <input
                type="number"
                name="weightTo"
                value={filters.weightTo}
                onChange={handleChange}
                placeholder="До"
                style={smallInput}
              />
              <select
                name="weightUnit"
                value={filters.weightUnit}
                onChange={handleChange}
                style={unitSelect}
              >
                <option value="KB">КБ</option>
                <option value="MB">МБ</option>
              </select>
            </div>
          </div>

          <div style={blockStyle}>
            <span style={labelStyle}>Ширина</span>
            <div style={inlineRowStyle}>
              <input
                type="number"
                name="widthFrom"
                value={filters.widthFrom}
                onChange={handleChange}
                placeholder="От"
                style={smallInput}
              />
              <input
                type="number"
                name="widthTo"
                value={filters.widthTo}
                onChange={handleChange}
                placeholder="До"
                style={smallInput}
              />
            </div>
          </div>

          <div style={blockStyle}>
            <span style={labelStyle}>Высота</span>
            <div style={inlineRowStyle}>
              <input
                type="number"
                name="heightFrom"
                value={filters.heightFrom}
                onChange={handleChange}
                placeholder="От"
                style={smallInput}
              />
              <input
                type="number"
                name="heightTo"
                value={filters.heightTo}
                onChange={handleChange}
                placeholder="До"
                style={smallInput}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;